import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import fullPayment from "../fragments/fullPayment"

const completePaymentQuery = gql`
  query CompletePayment($paymentOrderId: String!) {
    completePayment(paymentOrderId: $paymentOrderId) {
      ...fullPayment
    }
  }
  ${fullPayment}
`

export const completePaymentQueryKey = getQueryNames(completePaymentQuery)[0]

export default completePaymentQuery
